import React from "react";
import { Layout, LayoutProps } from "react-admin";
import MyMenu from "./Menu";

const LayoutWithMenu = (props: LayoutProps) => (
    <Layout {...props} menu={MyMenu} />
);

export default LayoutWithMenu;
